module.exports = __webpack_public_path__ + "media/images/background_efficacy_white-ecd7d49b947d39959c7da16ff998b0e1.png";